export function buildingHasActiveOrders(buildingObj, orders) {

	if (buildingObj === undefined) {
		return false;
	}

	return orders.some(order => order.active && order.building_id === buildingObj.id);
}